/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { forms } from './data';
import Mobile from '../../components/Mobile';
import DynamicFormItem from './DynamicFormItem';
import DynamicFormSections from './DynamicFormSections';

interface DynamicFormProps {
  id: string;
  onBack: () => void;
}

export default function DynamicForm({ id, onBack }: DynamicFormProps) {
  const {
    control, handleSubmit, reset,
  } = useForm();
  const data = React.useMemo(() => {
    const idx = parseInt(id, 10);
    if (Number.isNaN(idx)) return undefined;
    return forms[idx];
  }, [id]);

  const onSubmit = () => {
    toast.success('Thank you, the form has been submitted successfully.');
    reset();
  };

  const onError = () => {
    toast.error('The form has errors, please correct the error messages below and try again.');
  };

  const handleBack = () => {
    onBack();
  };

  if (!data) {
    return null;
  }

  return (
    <DynamicFormSections>
      <div className="mobile-layout">
        <div className="mobile-content">
          <div className="m-16">
            <div className="mobile-title">
              <h1>{data.title}</h1>
              <h2>{data.description}</h2>
            </div>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              {
                data.questions.map((question) => (
                  <DynamicFormItem key={question.label} question={question} control={control} />
                ))
              }
            </form>
          </div>
        </div>
        <div className="mobile-footer">
          <button className="btn" type="button" onClick={handleSubmit(onSubmit, onError)}>Submit</button>
          <Mobile>
            <button type="button" className="btn btn-outline" onClick={handleBack} style={{ marginTop: '0.5rem' }}>Back</button>
          </Mobile>
        </div>
      </div>
    </DynamicFormSections>
  );
}
